import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";

const queryString = require("query-string");

class Signicat extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired
  };

  componentDidMount() {
    const { cookies } = this.props;
    cookies.remove("state");

    if (this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      if (parsed.token) {
        // console.log(parsed.token);
        window.sessionStorage.accessToken = parsed.token;
        window.sessionStorage.idToken = parsed.id_token;
      } else {
        this.props.history.push("/404");
      }
    }
  }

  render() {
    return <Redirect to="/dashboard" />;
  }
}
export default withCookies(Signicat);



// WEBPACK FOOTER //
// ./src/containers/Signicat/Signicat.js